import React, {createContext, useContext, useEffect, useState} from "react";
import * as Api from '../../../../../api/cp';


export const PagesContext = createContext(null);

export const PagesProvider = ({event, children, setPagesLoaded}) => {
    const [pages, setPages] = useState(null);

    useEffect(handleGetPlatformPages, [event]);

    function handleGetPlatformPages() {
        Api.pages(event.eventKey)
            .then((response) => {
                if (response?.length) {
                    setPages(response);
                    setPagesLoaded(true);
                }
            })
    }

    function handlePageDetails(pageId) {
        return Api.pagesDetails(pageId);
    }

    async function handleAddPage(page) {
        const pageData = await Api.pagesCreate(event.eventKey, page);
        setPages((prev) => ([...prev, pageData]));
    }

    async function handleUpdatePage(page) {
        const pageData = await Api.pagesUpdate(page);

        setPages((prev) => {
            return prev.map((page) => {
                if (page.id === pageData.id) return pageData;

                return page;
            });
        });
    }

    async function handleSortPages(pagesId) {
        const sortedPages = await Api.pagesSort(event.eventKey, pagesId)
        setPages(sortedPages);
    }

    async function handleDeletePage(pageId) {
        await Api.pagesDelete(pageId);
        setPages((prev) => (prev.filter(({id}) => id !== pageId)));
    }

    const context = {
        event,
        pages,
        handleGetPlatformPages,
        handleAddPage,
        handleUpdatePage,
        handleDeletePage,
        handlePageDetails,
        handleSortPages,
    };

    return (
        <PagesContext.Provider value={context}>
            {children}
        </PagesContext.Provider>
    );
}

export const usePagesContext = () => useContext(PagesContext);
